import React from "react";
import Button from "@components/button";
import Link from "@components/link";
import { observer } from "mobx-react-lite";

import declension from "ati-core-utils/declension";
import i18nStrings from "../../strings/stings";
import BridgeCapitalLogo from "../../img/bridge-capital-logo.svg";
import PhoneIcon from "../../img/phone-icon.svg";
import CalculateLogoSVG from "../../img/calculate-logo.svg";
import FuelLogoSVG from "../../img/fuel-logo.svg";
import {
  PreviewStyles,
  PreviewIcon,
  HeaderStyles,
  PhonePreview,
  BodyStyles,
  Title,
  NameCompanyStyle,
  DescriptionStyle,
  PhoneStyle,
  WrapperButton,
  ButtonDescriptionStyle,
  CalculateLogo,
  FuelLogo,
} from "./SentencePart.styles";
import { useStore } from "../../store";
import { roles } from "../../const";
import { limitSeparate } from "../../utils/limitSeparate";
import interpolateReact from "../../utils/interpolateReact";

const SentencePart = ({ companyName }) => {
  const { globalModule } = useStore();
  const {
    showAdvance, limit, role, hasActiveRequest, showSend, ownership,
  } = globalModule;
  const strings = i18nStrings;
  const money = `${limitSeparate(limit)} ${declension(limit, strings.rubl)}`;

  const getDescription = () => {
    if (role === roles.carrier) return strings.descriptionForCarrier;
    if (role === roles.fuel) {
      return interpolateReact(strings.descriptionForFuel, [{
        from: "{{money}}",
        to: () => (
          <span className="money">{money}</span>
        ),
      }]);
    }
    if (role === roles.topShipper) {
      return interpolateReact(strings.descriptionForTopShipper, [{
        from: "{{money}}",
        to: () => (
          <>
            <br />
            <span className="money">{money}</span>
          </>
        ),
      }]);
    }
    return interpolateReact(strings.descriptionForShipper, [{
      from: "{{money}}",
      to: () => (
        <>
          <br />
          <span className="money">{money}</span>
        </>
      ),
    }]);
  };

  const getButtonText = () => {
    if (role === roles.carrier) return strings.buttonTitleForCarrier;
    if (role === roles.fuel) return strings.buttonTitleForFuel;

    return strings.buttonTitleForShipper;
  };

  const getButtonDescription = () => {
    if (role === roles.carrier) {
      return interpolateReact(strings.buttonDescriptionForCarrier, [{
        from: "{{money}}",
        to: () => (
          <>
            <br />
            <span className="money">{money}</span>
          </>
        ),
      }]);
    }
    if (role === roles.fuel) {
      return interpolateReact(strings.buttonDescriptionForFuel, [{
        from: "{{minutes}}",
        to: () => (
          <span className="minutes">{strings.minutes}</span>
        ),
      }]);
    }
    return interpolateReact(strings.buttonDescriptionForShipper, [{
      from: "{{minutes}}",
      to: () => (
        <span className="minutes">{strings.minutes}</span>
      ),
    }]);
  };

  const renderLogo = () => {
    if (role === roles.fuel) return <FuelLogo alt="" src={FuelLogoSVG} />;
    return <CalculateLogo alt="" src={CalculateLogoSVG} />;
  };

  return (
    <PreviewStyles>
      <HeaderStyles>
        <div><PreviewIcon alt="" src={BridgeCapitalLogo} /></div>
        <PhoneStyle><PhonePreview alt="" src={PhoneIcon} /><Link className="phone" href="tel:88005500992" theme="dark">{strings.phoneNumber}</Link></PhoneStyle>
      </HeaderStyles>
      <BodyStyles>
        <div>
          <Title>{strings.sentence}</Title>
          <br />
          <NameCompanyStyle>{ownership} {companyName}</NameCompanyStyle>
          <br />
          <DescriptionStyle>{getDescription()}</DescriptionStyle>
          <WrapperButton>
            <Button className="button" theme="primary" onClick={() => (hasActiveRequest ? showSend(true, "unsuccess") : showAdvance(true))}>
              {getButtonText()}
            </Button>
            <ButtonDescriptionStyle>
              {getButtonDescription()}
            </ButtonDescriptionStyle>
          </WrapperButton>
        </div>
        {renderLogo()}
      </BodyStyles>
    </PreviewStyles>
  );
};

export default observer(SentencePart);
